import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import React from "react";
import { MenuOptionType, ShiftInfo } from "../../../../../controls";

type Props = {
	setShiftId: Function;
	setShowDeleteModal: Function;
	setShowCreateModal: Function;
	setShowEditModal: Function;
};
export const useShiftsOptionsFunctions = ({
	setShiftId,
	setShowDeleteModal,
	setShowCreateModal,
	setShowEditModal,
}: Props) => {
	const getMenuOptions = (data: ShiftInfo) => {
		let options: MenuOptionType[] = [];
		if (!data) {
			options = options.concat([
				{
					name: "New Shift",
					key: "new_shift",
					onClick: () => {
						setShowCreateModal(true);
					},
					icon: <PlaylistAddIcon />,
				},
			]);
		} else {
			options = options.concat([
				{
					name: "New Shift",
					key: "new_shift",
					onClick: () => {
						setShowCreateModal(true);
					},
					icon: <PlaylistAddIcon />,
				},
				{
					name: "Edit Shift",
					key: "edit_shift",
					onClick: () => {
						setShiftId(data);
						setShowEditModal(true);
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Shift",
					key: "delete_shift",
					onClick: () => {
						setShiftId(data);
						setShowDeleteModal(true);
					},
					icon: <DeleteIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
